module.exports = __webpack_public_path__ + "img/yom_yes.34161a99.png";